import { Component, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BrandCampaign } from "../../../../../shared/models/brandCampaign";
import { PostLogStatus } from "../../../../../shared/enums/campaignPost.enums";
import {
  BrandPostLog,
  BrandPostLogWithAd,
} from "../../../../../shared/types/postLog.types";
import { BrandCampaignDialogService } from "../../../brand-campaign-dialog.service";

@Component({
  selector: "app-brand-campaign-posts-list-item",
  templateUrl: "./brand-campaign-posts-list-item.component.html",
  styleUrls: ["./brand-campaign-posts-list-item.component.scss"],
})
export class BrandCampaignPostsListItemComponent {
  @Input() campaign!: BrandCampaign;
  @Input() type!: PostLogStatus;
  @Input() post!: BrandPostLog;

  constructor(
    private readonly dialog: MatDialog,
    private readonly brandCampaignDialogService: BrandCampaignDialogService,
  ) {}

  public openAdConfig(post: BrandPostLog): void {
    if (!post.ad) {
      return;
    }

    this.dialog.closeAll();
    this.brandCampaignDialogService.showAd({
      postLog: post as BrandPostLogWithAd,
      campaign: this.campaign,
      campaignDetails: this.campaign.currentDetails,
    });
  }
}
